import { Box, Paper, Typography } from "@mui/material";
import { siteName } from "@/constants/config";
import useLayoutData from "@/hooks/useLayoutData";

function VerifyRequest() {
  const { contentHeight } = useLayoutData();

  return (
    <Box
      className="grid w-screen transition-all place-items-center"
      sx={{ height: contentHeight + "px" }}
    >
      <Paper
        elevation={4}
        className="!rounded-[20px] max-w-sm w-full"
        sx={{ width: `calc(100% - 32px)` }}
      >
        <div className="py-[30px]">
          <Typography className="!mb-[20px] text-center !text-[30px] !font-bold">
            Check your email
          </Typography>

          <Typography className="text-center !text-[17px] pb-[5px]">
            A sign in link has been sent to your
          </Typography>
          <Typography className="text-center !text-[17px]">email address.</Typography>

          <Typography variant="body1" className="text-center pt-[20px] opacity-80">
            <a
              href={"https://www." + siteName + ".com/"}
              className="no-underline text-inherit hover:underline"
            >
              {siteName + ".com"}
            </a>
          </Typography>
        </div>
      </Paper>
    </Box>
  );
}
export default VerifyRequest;
